import { Routes } from '@angular/router';

import { MsalGuard } from '@azure/msal-angular';

import { SiteSelectionGuard } from '@/app/core/util/site-selection-guard/site-selection.guard';
import { ROUTES } from '@/app/shared/util-common/navigation/routes.constants';

export const APP_ROUTES: Routes = [
  {
    path: ROUTES.INVENTORY.INVENTORY,
    loadChildren: () =>
      import('@/app/domains/inventory/inventory.routes').then((m) => m.inventoryRoutes),
    canActivateChild: [MsalGuard],
  },
  {
    path: ROUTES.BOARD,
    loadChildren: () =>
      import('@/app/domains/status-board/status-board.routes').then((m) => m.statusBoardRoutes),
    canActivate: [MsalGuard],
  },
  {
    path: ROUTES.DEPLOYMENTS.DEPLOYMENTS,
    loadChildren: () =>
      import('@/app/domains/deployments/deployments.routes').then((m) => m.deploymentsRoutes),
    canActivateChild: [MsalGuard],
  },

  {
    path: ROUTES.RELEASES.RELEASES,
    loadChildren: () =>
      import('@/app/domains/releases/releases.routes').then((mod) => mod.releasesRoutes),
    canActivateChild: [MsalGuard],
  },

  {
    path: ROUTES.SITE_SELECTION,
    loadChildren: () =>
      import('@/app/domains/site-selection/site-selection.routes').then(
        (m) => m.siteSelectionRoutes,
      ),
    canActivate: [MsalGuard],
    canMatch: [SiteSelectionGuard],
  },
  {
    path: ROUTES.HELP,
    loadChildren: () => import('@/app/domains/help-pages/help.routes').then((m) => m.helpRoutes),
    canActivateChild: [MsalGuard],
  },
  {
    path: ROUTES.ERROR.ERROR,
    loadChildren: () =>
      import('@/app/shared/ui-error-pages/error-pages.routes').then((mod) => mod.errorRoutes),
    canActivate: [MsalGuard],
  },
  {
    path: '**',
    redirectTo: ROUTES.BOARD,
  },
];
